<div class="flex flex-col">
  <div class="overflow-x-hidden">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Categoria
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Gênero
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Limite de Dados
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue">
                Mais
              </th>

              <!-- <th scope="col" class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"></th> -->
            </tr>
          </thead>

          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let questionario of questionarios">
              <td class="font-medium text-md text-chathams-blue whitespace-nowrap">
                <span
                  class="block w-3 h-3 ml-5 rounded-full"
                  [ngClass]="questionario.active ? 'bg-status-success' : 'bg-cerise-red'"
                ></span>
              </td>
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ questionario.name }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ questionario.categoria }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ questionario.genero | mask: '00.000.000/0000-00' }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ questionario.limiteDados }}
              </td>

              <td class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue">
                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [routerLink]="'editar/' + questionario.id"
                  title="Editar Questionarios"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#000000"
                    width="20"
                    height="20"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                >
                  <mat-icon class="w-6 h-6">more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    (click)="toogleEmpresaStatus(questionario.id!, questionario.active)"
                    *ngIf="!questionario.active"
                  >
                    <mat-icon>check</mat-icon>
                    <span>Ativar</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="toogleEmpresaStatus(questionario.id!, questionario.active)"
                    *ngIf="questionario.active"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Desativar</span>
                  </button>
                </mat-menu>
                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                >
                  <img src="./assets/icons/send.svg" alt="" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
